// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1bGqR","insightsList":"newBusinessInsightsMenu_insightsList__iWlrm","active":"newBusinessInsightsMenu_active__3MtYP"};